import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { pathOr } from 'ramda';
import React from 'react';
import MarkAsComplete from 'src/features/Users/Works/WorkGroups/WorkTile/MarkAsComplete';
import { humanizeUTCDateWithoutTimeZone } from 'src/utilities/formatDate';
import { getTheme } from 'src/utilities/siteSettings';
const theme = getTheme();

interface Props {
  handleReadMessage: (n: any) => void;
  handleMarkAsRead: (n: any) => void;
  notification: any;
}

const ReadMessageButton = styled(Button)({
  border: `1px solid ${theme.palette.primaryColor}`,
  borderRadius: '5px',
  display: 'flex',
  marginTop: '20px',
  padding: '14.5px 0px',
  placeContent: 'center',
  [theme.breakpoints.up('sm')]: {
    all: 'unset',
    background: 'none',
    border: 'none',
    color: theme.palette.primaryColor,
    cursor: 'pointer',
    display: 'block',
    font: 'inherit',
    margin: 0,
    padding: 0,
    textAlign: 'center',
  },
  width: '100%',
});



const CTAContainer = styled(Box)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '24px',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'column-reverse',
    gap: '21px',
  },
  width: '100%',
});

const InAppMessage = (props: Props) => {
  const { handleReadMessage, handleMarkAsRead, notification } = props;

  return (
    <Box>
      <Box px="32px" py="20px">
        <Typography
          color={theme.palette.gray.extraDarkGray}
          fontSize={'14px'}
          variant="caption"
        >
          {pathOr('', ['data', 'message'], notification)}
        </Typography>
        <CTAContainer>
          <ReadMessageButton onClick={() => handleReadMessage(notification)}>
            <Typography
              color={theme.palette.primaryColor}
              fontSize={'14px'}
              variant="caption"
            >
              Read Message
            </Typography>
          </ReadMessageButton>
          <Typography
            color={theme.palette.gray.softGray}
            fontSize={'12px'}
            variant="caption"
          >
            {humanizeUTCDateWithoutTimeZone(
              pathOr('', ['created_at'], notification),
              {
                format: 'ddd, MMM DD, YYYY, h:mm a',
              },
            )}
          </Typography>
          <MarkAsComplete  toolTipText={"Mark as Read"} handleMarkAsComplete={() => handleMarkAsRead(notification)} />
        </CTAContainer>
      </Box>
      <Divider sx={{ color: theme.palette.lightGray, margin: '10px 0px' }} />
    </Box>
  );
};
export default InAppMessage;
